import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import imgError404 from './images/img-error-404.png'
import constants from 'config/constants'

const Error404 = () => (
  <Wrapper>
    <div className="ui container">
      <div className="ui stackable grid" style={{ margin: 0 }}>
        <div className="eight wide computer sixteen wide tablet column" style={{ width: 541 }}>
          <img
            className="ui image fluid"
            style={{ margin: 'auto', width: 'auto', height: 'auto' }}
            src={imgError404}
            alt="Simplesat Error 404"
          />
        </div>
        <div style={{ margin: 'auto' }}>
          <div>
            <img
              className="ui fluid mini image"
              style={{ width: 170, height: 29.7, marginTop: 50 }}
              src={constants.simplesatLogoBlackUrl}
              alt="Simplesat Logo"
            />
            <div
              style={{
                fontWeight: 100,
                fontSize: 70,
                marginTop: 35,
                marginBottom: 40,
              }}
            >
              Whoops!
            </div>
            <div
              style={{
                marginTop: 10,
                fontWeight: 100,
                fontSize: 24,
                marginBottom: 20,
              }}
            >
              PAGE NOT FOUND
            </div>
            <p>
              The link you clicked may be broken or removed.
              <br />
              Find your way back to safety at the <Link to="/">dashboard homepage</Link>.
            </p>
          </div>
        </div>
      </div>
    </div>
  </Wrapper>
)

export default Error404

const Table = styled.div`
  display: table;
  min-height: 100%;
  height: 100%;
  width: 100%;
  background: white;
  padding: 1rem;
`

const TableCell = styled.div`
  display: table-cell;
  vertical-align: middle;
`

const Wrapper = (
  { children } // eslint-disable-line
) => (
  <Table>
    <TableCell>{children}</TableCell>
  </Table>
)



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/Error404/index.js